import React from "react";
import "./Modal.css";
import Button from "./Button";

export default function Modal({ open, icon, title, children, primary, onClose, closeLabel = "Chiudi" }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label={title} onClick={onClose}>
      <div className="modal-card" onClick={(e)=>e.stopPropagation()}>
        {icon && <div className="modal-icon">{icon}</div>}
        {title && <h3 className="modal-title">{title}</h3>}
        <div className="modal-content">{children}</div>
        <div className="modal-actions">
          {primary}
          <Button variant="ghost" onClick={onClose}>{closeLabel}</Button>
        </div>
      </div>
    </div>
  );
}
